/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

export { SystemPanelFrameComponent } from './system-panel-frame.component';
export { SystemPanelFrameModule } from './system-panel-frame.module';